import { Collapse, Switch, Tooltip } from 'antd';
import ProfileImageUploader from '../imageUploader/profileImageUploader'
// import { useDispatch, useSelector } from 'react-redux';
// import { checkProfileImage } from '../../Redux/Actions/CardAction';
const { Panel } = Collapse;

const ProfileImage = ({ edit }) => {
  // const dispatch = useDispatch();
  // const { checkProfile,theme } = useSelector((state) => state.cardReducer);
  const onChange = (key) => {
    console.log(key);
  };
  const onChangeToggle = (checked) => {
    console.log(`switch to ${checked}`);
    // dispatch(checkProfileImage(checked));
  };

 
  return (
    <Collapse defaultActiveKey={['0']} className='flex justify-between' onChange={onChange} >
      <Panel header="Profile Picture" key="1" className='w-full' >
        <ProfileImageUploader />
      </Panel>
      {/* {theme === 'modern' ? '':
        <p className='w-20 bg-white  border-b rounded-r-xl '>
          <p className='bg-slate-50 h-[47px] border-b rounded-r-md  py-3'>
            <Tooltip placement="top" title={`${checkProfile ? 'hide profile image' : 'show profile image'}`}>
              <Switch defaultChecked={checkProfile} className='bg-gray-400' onChange={onChangeToggle} />
            </Tooltip>
          </p>
        </p> 
        
      }  */}
    </Collapse>
  );
};
export default ProfileImage;